"use strict";

import Editor from "./markdown-editor/editor.js"

let MarkdownEditor = {
    options: {
        selector: '.markdown-editor',
        inputSubSelector: 'textarea',
        csrfTokenSelector: 'input[name="csrf_token"]',
    },
    tokens: {
        bold: { start: '**', middle: '', end: '**', label: 'Tučné', icon: 'bold' },
        italic: { start: '*', middle: '', end: '*', label: 'Kurzíva', icon: 'italic' },
        link: { start: '[', middle: '](https://...', end: ')', label: 'Odkaz', icon: 'link' },
        email: { start: '<mailto:', middle: '', end: '>', label: 'E-mail', icon: 'envelope' },
        phone: { start: '<tel:', middle: '', end: '>', label: 'Telefon', icon: 'phone' },
    }
};

MarkdownEditor.init = function (userOptions) {
    for (const prop in userOptions) {
        if (Object.prototype.hasOwnProperty.call(this.options, prop)) {
            this.options[prop] = userOptions[prop];
        }
    }

    this.initSelectors(document);
}

MarkdownEditor.initSelectors = function (rootElement) {
    const self = this;
    const elements = rootElement.querySelectorAll(this.options.selector);
    elements.forEach(function (element) {
        if (element.hasOwnProperty('moduleMarkdownEditorInitialized')) { return; }
        element.moduleMarkdownEditorInitialized = true;

        const textarea_element = element.querySelector(self.options.inputSubSelector);
        const csrf_token = document.querySelector(self.options.csrfTokenSelector).value;

        element.markdown_editor = new Editor(textarea_element, csrf_token);
    });
}

export {MarkdownEditor};